import { render, staticRenderFns } from "./ScopesSelector.vue?vue&type=template&id=10003a10&"
import script from "./ScopesSelector.vue?vue&type=script&lang=js&"
export * from "./ScopesSelector.vue?vue&type=script&lang=js&"
import style0 from "./ScopesSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports